import { plural } from "../../design/format/numbers.ts";

export const trackingHealthCopy = {
  medicao: {
    queda: (dia: string, compras: string, visitas: string, esperadas: string) =>
      `Em ${dia}, o Meta contou ${compras} compras, quando as visitas à página (${visitas}) indicavam umas ${esperadas}: ` +
      "a medição de compras pode ter quebrado.",
    pico: (dia: string, compras: string, visitas: string, esperadas: string) =>
      `Em ${dia}, o Meta contou ${compras} compras, quando as visitas à página (${visitas}) indicavam umas ${esperadas}: ` +
      "a medição pode estar contando compras a mais.",
  },
  medicaoProximo: "Confira o pixel e a API de conversões do site. Até a medição voltar, as compras do Meta não servem para decidir.",
  evento: {
    um: (conjunto: string, evento: string, gasto: string, dias: number) =>
      `${conjunto}, otimizado para ${evento}, gastou ${gasto} nos últimos ${dias} dias sem nenhum resultado no Meta, ` +
      "depois de ter resultados nos dias antes.",
    varios: (conjuntos: number, evento: string, gasto: string, dias: number) =>
      `${conjuntos} conjuntos otimizados para ${evento} gastaram ${gasto} nos últimos ${dias} dias sem nenhum resultado no Meta, ` +
      "depois de ter resultados nos dias antes.",
  },
  eventoProximo: "Confira se o evento ainda chega ao Meta: o pixel e a API de conversões do site.",
  eventos: {
    metaPurchases: "compras",
    leads: "leads",
    checkouts: "checkouts",
    addsToCart: "adições ao carrinho",
    contentViews: "visualizações de conteúdo",
    landingPageViews: "visitas à página",
    linkClicks: "cliques no link",
  },
  semUtm: (campanha: string, anuncios: number) =>
    `${campanha} tem ${anuncios} ${plural(anuncios, "anúncio ativo", "anúncios ativos")} com link sem utm: ` +
    `a loja não conta para a campanha as vendas ${plural(anuncios, "desse anúncio", "desses anúncios")}.`,
  semUtmProximo: "Confira os parâmetros de URL dos anúncios no Gerenciador: utm_campaign e utm_content.",
  pagina: {
    "fora-do-ar": (produto: string, status: number | undefined) =>
      `A página de ${produto} não abriu na última verificação${status === undefined ? "" : `: a loja respondeu ${status}`}.`,
    lenta: (produto: string) => `A página de ${produto} levou mais de 8 segundos para abrir na última verificação.`,
    "sem-resposta": (produto: string) => `A página de ${produto} não respondeu na última verificação.`,
    "preco-mudou": (produto: string, antes: string, agora: string) =>
      `O preço de ${produto} na loja mudou de ${antes} para ${agora} desde a verificação anterior.`,
  },
  levam: (anuncios: number, nomes: string) =>
    ` ${anuncios} ${plural(anuncios, "anúncio ativo leva", "anúncios ativos levam")} a essa página: ${nomes}` +
    `${anuncios > 3 ? ` e mais ${anuncios - 3}` : ""}.`,
  paginaProximo: "Abra a página e confira a loja: os anúncios seguem levando gente para ela.",
  precoProximo: "Confira se os anúncios não anunciam o preço antigo.",
  passo: "páginas dos produtos",
} as const;
